import { render, staticRenderFns } from "./PlantillaCreate.vue?vue&type=template&id=0f1f03e4&scoped=true"
import script from "./PlantillaCreate.vue?vue&type=script&lang=js"
export * from "./PlantillaCreate.vue?vue&type=script&lang=js"
import style0 from "./PlantillaCreate.vue?vue&type=style&index=0&id=0f1f03e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1f03e4",
  null
  
)

export default component.exports